export default "__VITE_ASSET__7851ce56__"